import { render, staticRenderFns } from "./seach.vue?vue&type=template&id=6c84a6dc"
import script from "./seach.vue?vue&type=script&lang=ts"
export * from "./seach.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports